"use strict";
// @ts-nocheck
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
exports.__esModule = true;
var React = __importStar(require("react"));
;
function xdn(_a) {
    var size = _a.size, _b = _a.color, color = _b === void 0 ? "currentColor" : _b;
    return React.createElement("svg", { width: size, height: size, viewBox: "0 0 24 24", fill: "none" },
        React.createElement("path", { d: "M9.98175 9H12.0353C13.0268 9 14.7975 9.60225 14.7975 12C14.7975 14.3977 13.0275 15 12.0353 15H9.9825L9.98175 9ZM11.1143 13.785H11.9648C12.6728 13.785 13.5225 13.3515 13.5225 12C13.5225 10.6485 12.6728 10.215 11.9648 10.215H11.115L11.1143 13.785ZM15.5775 9H16.002L19.8255 14.2695V9H20.25V15H19.8248L16.0012 9.846V15H15.576L15.5775 9ZM3.75 9H5.166V10.5H3.75V9ZM5.87475 9H7.29V10.5H5.87475V9ZM7.99875 9H9.4155V10.5H7.99875V9ZM7.99875 11.25H9.4155V12.75H7.99875V11.25ZM7.99875 13.5H9.4155V15H7.99875V13.5ZM5.87475 11.25H7.29V12.75H5.87475V11.25Z", fill: color }));
}
exports["default"] = xdn;
//# sourceMappingURL=xdn.js.map